import { getStaticProps as pageGetStaticProps } from '@/pages/blog/post/[slug]'
export { default, getStaticPaths } from '@/pages/blog/post/[slug]'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
